import type { ColorChange } from '../../../../../../backend/src/tiptap/editor/extensions/marks/suggestion'

export type TextColorOption = {
  labelKey: string
  value: string
}

export const TEXT_COLOR_OPTIONS: TextColorOption[] = [
  { labelKey: 'EDITOR.TEXT_COLOR.BLACK', value: '#000000' },
  { labelKey: 'EDITOR.TEXT_COLOR.RED', value: '#ff0000' },
  { labelKey: 'EDITOR.TEXT_COLOR.GREEN', value: '#00b050' },
  { labelKey: 'EDITOR.TEXT_COLOR.BLUE', value: '#0070c0' },
]

export function colorLabelKeyForValue(value: string): string | null {
  const option = TEXT_COLOR_OPTIONS.find((candidate) => candidate.value.toLowerCase() === value.toLowerCase()) ?? null
  return option?.labelKey ?? null
}

export function formatColorChangeLabel(colorChange: ColorChange, translate: (key: string) => string): string {
  const base = translate('EDITOR.TRACK_CHANGES.FORMAT_COLOR')
  const colorLabelKey = colorLabelKeyForValue(colorChange.to)
  return colorLabelKey === null ? base : `${base}: ${translate(colorLabelKey)}`
}
